var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourLogoHerePlaceholderPrimaryColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 230,
    fill: "none",
    stroke: "hsl(152, 24%, 32%)",
    strokeWidth: 12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 212,
    fill: "none",
    stroke: "hsl(152, 24%, 32%)",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 250) rotate(-12) skewX(-10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -85,
    fontFamily: "Impact, 'Arial Black', sans-serif",
    fontSize: 68,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "hsl(152, 24%, 32%)",
    letterSpacing: 2
  }, "YOUR"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 30,
    fontFamily: "Impact, 'Arial Black', sans-serif",
    fontSize: 135,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "hsl(152, 24%, 32%)",
    letterSpacing: -1
  }, "LOGO"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 115,
    fontFamily: "Impact, 'Arial Black', sans-serif",
    fontSize: 75,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "hsl(152, 24%, 32%)",
    letterSpacing: 4
  }, "HERE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourLogoHerePlaceholderPrimaryColor);
export default __webpack_public_path__ + "static/media/your-logo-here-placeholder-primary-color.bdcbdf8ac06c7ea8581cc3f5d3fc8ffe.svg";
export { ForwardRef as ReactComponent };